import { useQuery } from '@apollo/client/react'
import {
  BusinessCategoriesDocument,
  type BusinessCategoriesQuery,
} from '@/graphql/generated/graphql'

export type BusinessCategoryItem =
  BusinessCategoriesQuery['businessCategories']['items'][number]

/**
 * Catálogo de categorías de negocio. La query la consume tanto la feature
 * `organization` (campo `categoryIds`) como `businesses` (`businessCategoryIds`),
 * apunta al mismo tipo de dominio `BusinessCategory`.
 */
export function useBusinessCategories() {
  const { data, loading, error, refetch } = useQuery(BusinessCategoriesDocument, {
    variables: { take: 100 },
    fetchPolicy: 'cache-first',
  })

  return {
    categories: data?.businessCategories.items ?? [],
    loading,
    error,
    refetch,
  }
}
